import React from "react";
import useNearViewport from "../../hooks/useNearViewport";
import { useNavigate } from "react-router-dom"; // ← added
import "./LightingSection.css";
import Rectangle20 from "../../assets/Rectangle20.png.webp";

const LightingSection: React.FC = () => {
  const navigate = useNavigate();
  const { ref, isNear } = useNearViewport<HTMLDivElement>();

  const handleLearnMore = () => {
    // Navigate to products + pre-select "Security Lighting"
    navigate("/products?categories=Security Lighting");
  };

  return (
    <section className="lighting-section">
      {/* Background Image */}
      <div
        ref={ref} className="lighting-image"
        style={{ backgroundImage: isNear ? `url(${Rectangle20})` : "none" }}
      ></div>

      {/* Content Container */}
      <div className="lighting-container">
        <div className="lighting-content">
          {/* Subtitle */}
          <h3 className="lighting-subtitle">Protection through illumination</h3>

          {/* Title */}
          <h1 className="lighting-title">Security Lighting</h1>
        </div>

        {/* Button with navigation */}
        <button className="lighting-button" onClick={handleLearnMore}>
          Learn More
        </button>
      </div>
    </section>
  );
};

export default LightingSection;
